import { DataType } from 'src/app/views/transform/transformerDetail/column-calc-transform-detail/columnCalcViewModel';
import { DataTransform } from '../dataTransform';
import { SortInfo } from '../sortInfo';
import { TransformRule } from '../transformRule';
import { TransformType } from '../transformType';

export class ColumnCalcTransform extends DataTransform<ColumnCalcTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.columnCalc,nodeID);
      this.transformConfig = new ColumnCalcTransformConfig();
    }

    static fromJSON(data: any): ColumnCalcTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ColumnCalcTransform = Object.assign(new ColumnCalcTransform(0, 0, '', ''), data);
        instance.transformConfig = ColumnCalcTransformConfig.fromJSON(instance.transformConfig);

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class ColumnCalcTransformConfig {
    transformConfigId?: number;
    instance: string;
    farmType: number;
    transformType: TransformType;
    sortInfo?: SortInfo[];
    includeInResults?:string[];
    sampleStart: number;
    sampleEnd: number;
    runAll: boolean;
    rules: ColumnCalcTransformRule[];

    static fromJSON(data: any): ColumnCalcTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ColumnCalcTransformConfig = Object.assign(new ColumnCalcTransformConfig(), data);

        const rules: ColumnCalcTransformRule[] = [];
        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = ColumnCalcTransformRule.fromJSON(r);
                rules.push(rule);
            });
        }
        instance.rules = rules;
        return instance;
    }
}

export enum IfErrorType {
    fail = 0,
    null = 1,
    zero = 2
}

export class IfErrorTypeUtil {
    static toString(type: IfErrorType): string {
        switch (type) {
            case IfErrorType.fail:
                return 'Fail';
            case IfErrorType.null:
                return 'NULL';
            case IfErrorType.zero:
                return 'Zero';
        }
    }
}

export class ColumnCalcTransformRule extends TransformRule {
    targetDataType: DataType;
    targetField: string;
    expression: string;
    ifError: number;
    run: boolean;

    static fromJSON(data: any): ColumnCalcTransformRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ColumnCalcTransformRule = Object.assign(new ColumnCalcTransformRule(), data);

        return instance;
    }
}

export interface ColumnCalcRuleStats {
    rowHits: number;
    ruleIndex: number;
    groupHits: number;
    ruleDetails:string;
    rulePassFail:string;
}

export interface GlobalStats {
    rowHits: number;
    hitRate?: number;
    rowMisses?: number;
    groupHits?: number;
}

export interface ColumnCalcPreviewStats {
    globalStat: GlobalStats;
    ruleStats?: ColumnCalcRuleStats[];
}